import { ArrowLeft } from 'lucide-react'
import React, { useState } from 'react'

import { t } from '../../../../common/i18n.js'
import type { Language } from '../../../../common/types/i18n.js'
import { Button } from '../../button/button.js'
import { CropperResult, ImageCropper } from '../../cropper/cropper.js'
import { BaseModal } from '../base-modal/base-modal.js'

export interface CropModalProps {
    isOpen: boolean
    src?: string | null
    lang: Language
    onClose: () => void
    onComplete?: (result: CropperResult) => void
    title?: string
}

export const CropModal: React.FC<CropModalProps> = ({
    isOpen,
    src,
    lang,
    onClose,
    onComplete,
    title,
}) => {
    const resolvedTitle = title ?? t.cropper.cropTitle(lang)
    const [actions, setActions] = useState<
        {
            label: string
            onClick: () => void
            disabled?: boolean
            variant?: 'primary' | 'secondary' | 'alert'
        }[]
    >([])

    return (
        <BaseModal isOpen={isOpen} onClose={onClose} className="crop-modal">
            {/* Header */}
            <div className="crop-modal__header">
                <div className="crop-modal__link">
                    <Button
                        iconLeft={ArrowLeft}
                        onClick={onClose}
                        size="medium"
                        variant="link"
                        text={t.cropper.backToSelect(lang)}
                    />
                </div>

                <div className="crop-modal__title">{resolvedTitle}</div>
            </div>

            {/* Body */}
            <div className="crop-modal__body">
                {src ? (
                    <ImageCropper
                        src={src}
                        lang={lang}
                        onComplete={(result) => {
                            onComplete?.(result)
                        }}
                        onCancel={onClose}
                        onActionsChange={setActions}
                    />
                ) : (
                    <div>{t.common.noImageSelected(lang)}</div>
                )}
            </div>

            {/* Footer */}
            <footer className="crop-modal__footer">
                {actions.map((action) => (
                    <Button
                        key={action.label}
                        text={action.label}
                        onClick={action.onClick}
                        isDisabled={action.disabled}
                        variant={action.variant ?? 'secondary'}
                        size="medium"
                    />
                ))}
            </footer>
        </BaseModal>
    )
}
